module.exports = __webpack_public_path__ + "static/media/_DSC0004.466e32c4.avif";